module.exports = __webpack_public_path__ + "a24013795006b153c1d154545098c890.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_65.jpg
// module id = 1685
// module chunks = 5